import type { FormTarget } from "@magento/types";

const placements: FormTarget[] = [
  "contactDetails_before",
  "contactDetails_after",
  "shippingAddress_before",
  "shippingAddress_after",
  "billingaddress_before",
  "billingaddress_after",
  "buttonDelivery_before",
  "buttonPlaceOrder_before",
];

export const isValidTarget = (target: string): target is FormTarget => {
  const isValid = (placements as readonly string[]).includes(target);
  if (!isValid) {
    console.warn(`Warning: Order Attribute with target '${target}' is not a valid FormTarget.`);
  }
  return isValid;
};
